import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { UI } from "../data/content";
import { Reveal, HeroBand, ContactModule, usePageMeta } from "../components/kit";

export default function Contact() {
  const T = UI.pages.contact;
  usePageMeta(T.metaTitle, T.metaDesc);
  const [form, setForm] = useState({ name: "", company: "", email: "", phone: "", service: "General", message: "", consent: false });
  const [state, setState] = useState({ status: "idle", msg: "" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setState({ status: "loading", msg: "" });
    try {
      await api.post("/contact", { ...form, sourceUrl: window.location.href });
      setState({ status: "done", msg: T.successMsg });
    } catch (err) {
      setState({ status: "error", msg: formatApiErrorDetail(err.response?.data?.detail) });
    }
  };

  return (
    <div data-testid="contact-page">
      <HeroBand image="bridge" eyebrow={T.eyebrow} title={T.title}
        standfirst={T.standfirst}
        compact testId="contact-hero" />

      <section className="k-section">
        <div className="k-container grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <ContactModule heading={T.direct} />
            <Reveal className="mt-10">
              <p className="eyebrow mb-3">{T.officesEyebrow}</p>
              <p className="text-sm text-ink-muted leading-relaxed">
                {T.officesLine}
              </p>
              <p className="text-sm text-ink-muted mt-3" style={{ fontVariantNumeric: "tabular-nums" }}>
                {T.entityLine}
              </p>
              <p className="text-sm text-ink-muted mt-2" data-testid="contact-reg-office">{T.regOffice}</p>
            </Reveal>
          </div>

          <Reveal delay={0.08} className="lg:col-span-7">
            {state.status === "done" ? (
              <div className="border border-[var(--brand)] p-10 bg-paper-alt" data-testid="contact-confirmation">
                <h2 className="k-h3 mb-4 text-brand">{T.successTitle}</h2>
                <p className="text-ink-muted leading-relaxed">{state.msg}</p>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-6" data-testid="contact-form">
                <div className="grid sm:grid-cols-2 gap-6">
                  <div>
                    <label className="field-label" htmlFor="c-name">{T.name}</label>
                    <input id="c-name" required className="field-input" value={form.name} onChange={set("name")} data-testid="contact-name-input" />
                  </div>
                  <div>
                    <label className="field-label" htmlFor="c-company">{T.org}</label>
                    <input id="c-company" className="field-input" value={form.company} onChange={set("company")} data-testid="contact-company-input" />
                  </div>
                </div>
                <div className="grid sm:grid-cols-2 gap-6">
                  <div>
                    <label className="field-label" htmlFor="c-email">{T.email}</label>
                    <input id="c-email" type="email" required className="field-input" value={form.email} onChange={set("email")} data-testid="contact-email-input" />
                  </div>
                  <div>
                    <label className="field-label" htmlFor="c-phone">{T.phone}</label>
                    <input id="c-phone" className="field-input" value={form.phone} onChange={set("phone")} data-testid="contact-phone-input" />
                  </div>
                </div>
                <div>
                  <label className="field-label" htmlFor="c-service">{T.area}</label>
                  <select id="c-service" className="field-input" value={form.service} onChange={set("service")} data-testid="contact-service-select">
                    {T.areas.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
                  </select>
                </div>
                <div>
                  <label className="field-label" htmlFor="c-message">{T.message}</label>
                  <textarea id="c-message" required rows={5} className="field-input" value={form.message} onChange={set("message")} data-testid="contact-message-input" />
                </div>
                <label className="flex items-start gap-3 text-sm text-ink-muted cursor-pointer">
                  <input type="checkbox" checked={form.consent} onChange={set("consent")} required className="mt-1 accent-[var(--brand)]" data-testid="contact-consent-checkbox" />
                  <span>{T.consentPre}<Link to="/privacy" className="text-brand underline">{T.consentLink}</Link>.</span>
                </label>
                {state.msg && state.status === "error" && (
                  <p className="text-sm text-red-600" data-testid="contact-error">{state.msg}</p>
                )}
                <button type="submit" className="btn-primary" disabled={state.status === "loading"} data-testid="contact-submit-btn">
                  {state.status === "loading" ? T.sending : T.submit}
                </button>
              </form>
            )}
          </Reveal>
        </div>
      </section>
    </div>
  );
}
